import { useContext } from "react";

import { ClientSettingsContext } from "@contexts/ClientSettings";

export const useClientSettings = () => useContext(ClientSettingsContext);
export const useClientApiKeys = () => useClientSettings().apiKeys;
